import { transparentize } from 'polished';
import React from 'react';
import { useTheme } from 'styled-components';

/**
 * LogoWarning
 *
 * This component renders an icon that looks like a piece of opened mail.
 */
export const LogoWarning: React.FC<React.PropsWithChildren> = (rest) => {
  const theme = useTheme();
  /* eslint-disable max-len */
  return (
    <svg
      viewBox="0 0 114 102"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <desc>Created with Sketch.</desc>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g fillRule="nonzero">
          <path
            d="M63.7522124,4.15311258 L112.743363,89.2386755 C115.787611,94.4921854 112,101.059073 105.946903,101.059073 L7.92920354,101.059073 C1.87610619,101.059073 -1.91150442,94.4921854 1.13274336,89.2386755 L50.1238938,4.15311258 C53.1327434,-1.13589404 60.7079646,-1.13589404 63.7522124,4.15311258 Z"
            fill={transparentize(0.2, theme.colors.error)}
          />
          <path
            d="M59.4690265,17.7483444 L97.8761062,84.4821192 C99.0088496,86.4699338 97.5929204,88.9192053 95.3274336,88.9192053 L18.5132743,88.9192053 C16.2477876,88.9192053 14.8318584,86.4344371 15.9646018,84.4821192 L54.3716814,17.7483444 C55.5044248,15.7605298 58.3362832,15.7605298 59.4690265,17.7483444 Z"
            fill={theme.colors.error}
          />
          <path
            d="M53.9292035,35.9618543 L60.3716814,35.9618543 L60.3716814,68.5813706 L53.9292035,68.6587144 L53.9292035,35.9618543 Z M57.3982301,72.7192658 C60.0884956,72.7192658 61.9292035,75.0782529 61.9292035,77.1665364 C61.9292035,79.6415392 60.0884956,81.9618543 57.3982301,81.9618543 C54.3893805,81.9618543 52.5486726,79.6028673 52.5486726,77.1665364 C52.5486726,75.0395809 54.3893805,72.7192658 57.3982301,72.7192658 Z"
            fill={theme.colors.white}
          />
        </g>
      </g>
    </svg>
  );
}; /* eslint-enable max-len */
